import { LEGACY_VISITOR_ID_COOKIE, VISITOR_ID_COOKIE } from './types';

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name}=([^;]*)`),
  );
  return match?.[1] ? decodeURIComponent(match[1]) : undefined;
}

/**
 * Reads the first-party visitor ID from the browser cookie.
 * Prefers the canonical `_rr_id` cookie and falls back to the legacy `rr_vid`
 * cookie for continuity. Returns undefined server-side or when both are absent.
 */
export function getVisitorId(): string | undefined {
  return readCookie(VISITOR_ID_COOKIE) ?? readCookie(LEGACY_VISITOR_ID_COOKIE);
}
